import React, { useContext } from 'react';
import { UserContext } from '../../../hooks/Contexts';
import { isOptionType } from '../../fields/constants/subtypes';

const OptionBatch = ({
  fieldsets,
  determineField,
  determineOpt,
  handleClearAll,
  handleUpdateAll,
  selectedField,
  selectedOpt,
  submissionCount,
}) => {
  const userIsAdmin = useContext(UserContext).isAdmin;

  return (
    <div className='creation-form'>
      <div className='row'>
        <h3>Field to update:</h3>
        <div className='full'>
          <div className='select-input'>
            <select
              name='field-select'
              id='field-select'
              onChange={(e) => determineField(e.target.value)}
            >
              <option label='Please select...' value={''} />
              {fieldsets.map((fs) => {
                return (
                  <optgroup key={fs.id} label={fs.name}>
                    {fs.fields
                      .filter(
                        (f) => isOptionType(f.type) && f.type != 'checkbox'
                      )
                      .map((field) => {
                        return (
                          <option
                            key={field.id}
                            label={field.name}
                            value={field.id}
                          />
                        );
                      })}
                  </optgroup>
                );
              })}
            </select>
          </div>
        </div>
      </div>

      {selectedField?.informs_global && (
        <div className='row'>
          <h3>Attention</h3>
          <div className='full'>
            <p>
              This field manages the global quota and cannot be batch updated.
              If you believe a batch update is necessary, submit a ticket to IT
              to discuss possible solutions.
            </p>
            {userIsAdmin && (
              <p>
                Admins - Manage quotas for:{' '}
                <a target='_blank' href={`/manage/fields/${selectedField.id}`}>
                  <i>{selectedField.name}</i>
                </a>
              </p>
            )}
          </div>
        </div>
      )}

      <div className='row'>
        <h3>Choose new option:</h3>
        <div className='full'>
          {selectedField && (
            <div className='select-input'>
              <select
                name='option-update'
                id='option-update'
                onChange={(e) => determineOpt(e.target.value, selectedField)}
              >
                <option label='Please select...' value='' />
                <optgroup label='Clear Responses'>
                  <option label='CLEAR RESPONSES' value='destroy' />
                </optgroup>
                <optgroup label='Update Responses with option:'>
                  {selectedField?.options.map((opt) => {
                    return (
                      <option key={opt.id} label={opt.name} value={opt.id} />
                    );
                  })}
                </optgroup>
              </select>
            </div>
          )}
        </div>
      </div>

      <div className='controls'>
        <div className='right'>
          <h3>Submission count: {submissionCount}</h3>
          {selectedField?.informs_global ? (
            <button disabled={true}>Update Submissions</button>
          ) : selectedOpt == 'destroy' ? (
            <button onClick={handleClearAll}>Clear Responses</button>
          ) : selectedOpt ? (
            <button onClick={handleUpdateAll}>Update Submissions</button>
          ) : (
            <button disabled={true}>Update Submissions</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OptionBatch;
